import React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';
import Avatar from './Avatar';
import { OrgContextLink } from './OrgContextProvider';

const UserProfileSegment = () => {
	const auth = useAuth();

	return (
		<React.Fragment>
		{ auth?.profile
			? <React.Fragment>
					<OrgContextLink to={`/profile`}>
						{<React.Fragment>&nbsp;<Avatar src={`/api/users/public/${auth.profile.id}/avatar?size=small`} size="20px" /></React.Fragment>}
						&nbsp;
						<span style={{color: '#ffff66'}}>{auth.profile?.name}</span>
					</OrgContextLink>
					&nbsp;
					[<Link to="/auth/logout">
							Logout
					</Link>]
				</React.Fragment>
			: <Link to="/auth/login">Login</Link>
		}
		</React.Fragment>
	);
};

export default UserProfileSegment;
